import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Upload } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminGallery = () => {
  const [beforePhoto, setBeforePhoto] = useState(null);
  const [afterPhoto, setAfterPhoto] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!beforePhoto || !afterPhoto || !title) {
      toast.error('Please provide before/after photos and a title');
      return;
    }

    const formData = new FormData();
    formData.append('before_photo', beforePhoto);
    formData.append('after_photo', afterPhoto);
    formData.append('title', title);
    formData.append('description', description);

    try {
      await axios.post(`${BACKEND_URL}/api/admin/gallery`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      toast.success('Before/After photos added successfully!');
      
      // Reset form
      setBeforePhoto(null);
      setAfterPhoto(null);
      setTitle('');
      setDescription('');
    } catch (error) {
      toast.error('Failed to upload photos');
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-8">
      <Card>
        <CardHeader>
          <CardTitle>Add Before/After Photos</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label>Title</Label>
              <Input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="e.g., Kitchen Deep Clean"
                className="mt-2"
              />
            </div>

            <div>
              <Label>Description</Label>
              <Input
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Brief description of the transformation"
                className="mt-2"
              />
            </div>

            <div>
              <Label>Before Photo</Label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setBeforePhoto(e.target.files[0])}
                className="mt-2"
              />
              {beforePhoto && (
                <p className="text-sm text-green-600 mt-1">✓ {beforePhoto.name}</p>
              )}
            </div>

            <div>
              <Label>After Photo</Label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setAfterPhoto(e.target.files[0])}
                className="mt-2"
              />
              {afterPhoto && (
                <p className="text-sm text-green-600 mt-1">✓ {afterPhoto.name}</p>
              )}
            </div>

            <Button type="submit" className="w-full">
              <Upload className="mr-2" size={16} />
              Upload Before/After Photos
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
